<template>
	<div class="auBox" v-loading="loading" element-loading-text="听力拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
		<audio
			class="myAudio"
			:ref="refName"
			v-if="aFlag"
			@timeupdate="updateTime"
			preload="auto"
			@loadedmetadata="loadMetadata"
			@canplaythrough="handleCanPlayThrough"
			@ended="audioEnded"
		>
			<source :src="audioSrc || audioUrl" type="audio/mpeg" />
			<source :src="audioSrc || audioUrl" type="audio/ogg" />
			Your browser does not support this audio format.
		</audio>
		<div class="audioBox" :class="types == 3 ? 'audioBox1' : ''">
			<div class="auIcon supHove3" @click="playFn">
				<i class="el-icon-video-play" v-show="!playFlag"></i>
				<i class="el-icon-video-pause" v-show="playFlag"></i>
			</div>
			<div class="auP">
				<div class="auPTit ellipsis-1" v-if="types != 3" :title="audioName || title">{{ audioName || title }}</div>
				<div class="auPJd">
					<el-slider class="jdH" v-model="jdval" @change="jdChage" :max="jdMax" :format-tooltip="formatTooltip"></el-slider>
					<p>
						<span>{{ currentTime }}</span>
						/ {{ duration }}
					</p>
				</div>
			</div>
			<div class="auRig" v-if="types == 2">
				<i class="el-icon-caret-left supHove3" @click="yusFn('-')"></i>
				<h2>
					<span>x</span>
					{{ bsData[bsIns] }}
				</h2>
				<i class="el-icon-caret-right supHove3" @click="yusFn('+')"></i>
			</div>
			<div class="auRig auRig1" v-if="types == 3">
				<p class="supHove3">语速调节</p>
				<h2>
					<i class="el-icon-caret-top supHove3" @click="yusFn('+')"></i>
					<span>x</span>
					{{ bsData[bsIns] }}
					<i class="el-icon-caret-bottom supHove3" @click="yusFn('-')"></i>
				</h2>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import jsFileDownload from 'js-file-download';

export default {
	name: 'myAudio',
	data() {
		return {
			loading: false,
			currentTime: '00:00',
			duration: '00:00',
			bsData: ['0.5', '0.75', '1', '1.25', '1.5', '1.75'],
			mp3Info: null,
			sound: null,
			bsIns: 2,
			playFlag: false,
			jdMax: 0,
			jdval: 0,
			audVal: 0,
			audioFile: '',
			audioName: '',
			audioSrc: '',
			aFlag: true,
			aNliu: ''
		};
	},
	props: {
		types: {
			type: String,
			default: '1' // 1正常 2正常带调速 3夜间
		},
		title: {
			type: String,
			default: ''
		},
		refName: {
			type: String,
			default: 'audioPlayer'
		},
		audioResourceFileId: {
			type: Number,
			default: 0
		},
		audioUrl: {
			type: String,
			default: ''
		}
	},
	methods: {
		formatTooltip(val) {
			return this.formatTime(val);
		},
		xzAudio() {
			console.log(this.aNliu, 77777);
			if (this.aNliu) {
				jsFileDownload(this.aNliu, decodeURIComponent(this.audioName));
			}
		},
		yusFn(type) {
			if (type == '-') {
				if (this.bsIns == 0) return;
				this.bsIns--;
			} else {
				if (this.bsIns == 5) return;
				this.bsIns++;
			}
			const audioPlayer = this.$refs[this.refName];
			if (audioPlayer) {
				audioPlayer.playbackRate = this.bsData[this.bsIns];
			}
		},
		jdChage(val) {
			if (!this.audioUrl && !this.audioSrc) {
				this.$message({
					message: '暂无音频哦~',
					type: 'warning'
				});
				return;
			}
			console.log(val, 888);
			this.$refs[this.refName].currentTime = val;
		},
		playFn() {
			if (!this.audioUrl && !this.audioSrc) {
				this.$message({
					message: '暂无音频哦~',
					type: 'warning'
				});
				return;
			}
			this.playFlag = !this.playFlag;
			if (this.playFlag) {
				if (this.refName != 'audioPlayer') {
					this.$emit('fullhdFn', this.$refs[this.refName], this.refName);
				}
				this.$refs[this.refName]?.play();
			} else {
				this.$refs[this.refName]?.pause();
			}
		},
		handleCanPlayThrough(event) {
			const audio = event.target; // event.target
			this.jdMax = audio.duration;
			this.jdval = audio.currentTime;
			this.duration = this.formatTime(audio.duration);
			this.currentTime = this.formatTime(audio.currentTime);
		},
		updateTime(event) {
			const audio = event.target;
			this.jdval = audio.currentTime;
			this.currentTime = this.formatTime(audio.currentTime);
		},
		loadMetadata(event) {
			const audio = event.target;
			this.duration = this.formatTime(audio.duration);
		},
		audioEnded() {
			this.playFlag = false;
			this.currentTime = '00:00';
			this.jdval = 0;
			console.log('Audio has ended.');
		},
		formatTime(seconds) {
			const m = Math.floor(seconds / 60) % 60;
			const s = Math.floor(seconds) % 60;
			return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
		}
	},
	mounted() {
		if (this.audioResourceFileId) {
			this.aFlag = false;
			this.loading = true;
			this.$http
				.get('api/app/common/getUrl', {
					params: {
						fileId: this.audioResourceFileId,
						clientType: 1
					}
				})
				.then((res) => {
					this.audioName = res.fileName;
					if (res.code == 200) {
						axios({
							method: 'get',
							url: res.msg,
							responseType: 'blob', // 返回类型为数据流
							headers: {
								clientType: 1,
								token: `${localStorage.getItem('token')}`
							}
						}).then((red) => {
							this.loading = false;
							if (red && red.data) {
								this.aNliu = red.data;
								const blob = new Blob([red.data], { type: 'audio/mpeg' });
								this.audioSrc = URL.createObjectURL(blob);
								this.aFlag = true;
							}
						});
					}
				});
		}
	}
};
</script>
<style lang="scss" scoped>
.auBox {
	height: 66px;
	margin-bottom: 23px;
}
.audioBox {
	width: 100%;
	height: 66px;
	background: linear-gradient(180deg, #ffffff 0%, #f1f1f1 100%);
	border-radius: 8px;
	border: 1px solid #e0e0e0;
	display: flex;
	padding: 0 19px 0 13px;
	display: flex;
	align-items: center;
	box-sizing: border-box;
	.auIcon {
		width: 42px;
		height: 42px;
		background: #1d7b3a;
		border-radius: 50%;
		color: #fff;
		font-size: 18px;
		margin-right: 17px;
		cursor: pointer;
		position: relative;
		i {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			font-size: 50px;
		}
	}
	.auP {
		flex: 1;
		display: flex;
		flex-direction: column;
		font-size: 14px;
		.auPTit {
			color: #1e1e1e;
			margin-bottom: 2px;
			text-align: left;
			max-width: 780px;
			// overflow: hidden; /* 确保超出容器的内容被裁剪 */
			// white-space: nowrap; /* 确保文本在一行内显示 */
			// text-overflow: ellipsis; /* 超出部分显示省略号 */
		}
		.auPJd {
			width: calc(100% - 4px);
			margin-left: 6px;
			box-sizing: border-box;
			position: relative;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.jdH {
				width: calc(100% - 124px);
				::v-deep .el-slider__runway {
					margin: 8px 0;
				}
				::v-deep .el-slider__button {
					width: 9px;
					height: 9px;
					background: #1d7b3a;
					border: 2px solid #1d7b3a;
				}
				::v-deep .el-slider__bar {
					background: #1d7b3a;
				}
			}
			p {
				color: #a9a9a9;
				span {
					color: #000;
				}
			}
		}
	}
	.auRig {
		margin-left: 44px;
		display: flex;
		align-items: center;
		color: #1d7b3a;
		cursor: pointer;
		font-size: 24px;
		h2 {
			font-size: 14px;
			color: #000000;
			margin: 0 12px;
			width: 38px;
			text-align: center;
			span {
				margin-right: 2px;
			}
		}
	}
	.auRig1 {
		color: #00b7ff;
		font-size: 14px;
		margin-left: 60px;
		p {
		}
		h2 {
			color: #fff;
			position: relative;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-left: 24px;
			i {
				font-size: 16px;
			}
			.el-icon-caret-top {
				position: absolute;
				left: 50%;
				top: -13px;
				transform: translateX(-55%);
			}
			.el-icon-caret-bottom {
				position: absolute;
				left: 50%;
				transform: translateX(-55%);
				bottom: -15px;
			}
		}
	}
}
.audioBox1 {
	background: #465161;
	border: #465161;
	.auIcon {
		background: transparent;
		i {
			font-size: 46px;
			color: #02b9ff;
		}
	}
	.auPJd {
		p {
			span {
				color: #fff !important;
			}
		}
	}
	.jdH {
		::v-deep .el-slider__button {
			background: #fff !important;
			border: 2px solid #fff !important;
		}
		::v-deep .el-slider__bar {
			background: #fff !important;
		}
		::v-deep .el-slider__runway {
			background: #666e7b;
		}
	}
}
</style>
